import PropTypes from 'prop-types';
import React from 'react';
import Image from 'next/image';
import LightboxContainer from './Lightbox.styled';
import ImageGallery from 'react-image-gallery';
import Heading from '../../Typography/Heading';
import BodyCopy from '../../Typography/BodyCopy';

export class Lightbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
    };

    this.handleSlideChange = this.handleSlideChange.bind(this);
  }

  handleSlideChange(currentIndex) {
    this.setState({ currentIndex });
  }

  buildLightboxData() {
    let lightboxImages =
      this.props.lightboxData && this.props.lightboxData.lightboxMedia
        ? this.props.lightboxData.lightboxMedia
            .filter((obj) => obj.__typename === 'ContentfulMedia')
            .map((obj, i) => {
              let { media } = obj;
              return {
                renderItem: () => {
                  return (
                    <div className="image-gallery-image">
                      <Image
                        className="gallery-image"
                        src={media.file.url}
                        fill
                      />
                      {obj.description ? (
                        <BodyCopy
                          className="gallery-description"
                          paragraphText={obj.description}
                          key={i}
                        />
                      ) : null}
                    </div>
                  );
                },
              };
            })
        : null;
    return lightboxImages;
  }

  render() {
    let lightboxImages = this.buildLightboxData();
    return lightboxImages && lightboxImages.length > 0 ? (
      <LightboxContainer>
        {this.props.lightboxData && this.props.lightboxData.lightboxHeader ? (
          <Heading
            headingSize={'medium'}
            headingText={this.props.lightboxData.lightboxHeader}
            isCentered={true}
            headingTag={'h3'}
          />
        ) : null}
        <ImageGallery
          items={lightboxImages}
          lazyLoad={true}
          showFullscreenButton={false}
          useBrowserFullscreen={false}
          showNav={true}
          showBullets={true}
          showThumbnails={false}
          showPlayButton={false}
          onSlide={this.handleSlideChange}
          startIndex={this.state.currentIndex}
          renderLeftNav={(onClick, disabled) => {
            return (
              <button
                type="button"
                onClick={onClick}
                disabled={disabled}
                className="image-gallery-left-arrow"
                aria-label="Previous Slide"
              />
            );
          }}
          renderRightNav={(onClick, disabled) => {
            return (
              <button
                type="button"
                onClick={onClick}
                disabled={disabled}
                className="image-gallery-right-arrow"
                aria-label="Next Slide"
              />
            );
          }}
          bulletClass={'lightbox-bullet'}
          key={Date.now()}
        />
      </LightboxContainer>
    ) : null;
  }
}

Lightbox.propTypes = {
  lightboxData: PropTypes.shape({
    lightboxHeader: PropTypes.any,
    lightboxMedia: PropTypes.shape({
      filter: PropTypes.func,
    }),
  }),
};

export default Lightbox;
